import styled from 'styled-components';

export const OnsiteLocationMainWrapper = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: #09090A;
	overflow: hidden;
`;

export const GradientPurple = styled.div`
	position: absolute;
	top: 20%;
	bottom: 48%;
	left: 24%;
	right: 24%;
	width: 52vw;
	height: 31vh;
	border-radius: 744px;
	opacity: 0.2;
	background: #FF6AE6;
	filter: blur(130px);

	&.left {
		top: 17%;
		bottom: 52%;
		left: 14%;
		right: 35%;
	}
`;

export const GradientYellow = styled.div`
	position: absolute;
	top: 22%;
	bottom: 23%;
	left: 18%;
	right: 30%;
	width: 52vw;
	height: 54vh;
	border-radius: 742px;
	opacity: 0.2;
	background: #FFF85C;
	filter: blur(130px);

	&.left {
		top: 19%;
		bottom: 27%;
		left: 8%;
		right: 41%;
	}
`;

export const OnsiteLocationMainBody = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export const OnsiteLocationMainFooter = styled.div`
	position: fixed;
	bottom: 48px;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const BackButton = styled.button`
	position: absolute;
	left: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 20px;
	gap: 8px;
	border-radius: 100px;
	background: transparent;

	:hover, :active {
		background:  transparent;
	}
`;

export const Button = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px 24px;
	gap: 8px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	transition: 250ms all;

	label, path, a {
		transition: 250ms all;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);

		label, a {
			color: #BFBBCF !important;
		}

		svg>path {
			fill: #BFBBCF !important;
		}
	}

	&.gradient {
		@property --gradColor1 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		@property --gradColor2 {
			syntax: '<color>';
			initial-value: rgba(255, 255, 255, 0);
			inherits: false;
		}

		background: linear-gradient(0deg, var(--gradColor1) 0%, var(--gradColor2) 100%), linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%); 
  		transition: --gradColor1 250ms, --gradColor2 250ms;

		:hover {
			--gradColor1: rgba(255, 255, 255, 0.10);
  			--gradColor2: rgba(255, 255, 255, 0.10);
		}
		
		:active {
			--gradColor1: rgba(0, 0, 0, 0.20);
  			--gradColor2: rgba(0, 0, 0, 0.20);

			label {
				color: #09090A !important;
			}

			svg>path {
				fill: #09090A !important;
			}
		}
	}

	&.link {
		margin-left: 16px;
		padding: 0;

		a {
			color: #E5E4EC;
			font-size: 13px;
			font-weight: 600;
			line-height: 16px;
			cursor: pointer;
			padding: 16px 24px;

			&:active, &:focus {
				box-shadow: none;
			}
		}
	}

	&.highlight-rainbow {
		label {
			background: linear-gradient(90deg, #FFFD62 0%, #FF6AE6 100%);
			background-clip: text;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		path {
			fill: #FFF97D !important;
		}
	}
`;

export const ButtonLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	cursor: pointer;
`;

export const CheckboxButton = styled.label`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 184px;
	padding: 16px 24px;
	gap: 8px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	white-space: nowrap;
	transition: 250ms all;
	cursor: pointer;

	input[type=checkbox] {
		width: 16px;
		height: 16px;
		accent-color: #FFFFFF;
		cursor: pointer;
	}

	:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	:active {
		background: rgba(255, 255, 255, 0.05);
	}

	&.onsite-chechbox-button {
		padding: 8px 16px;
		gap: 6px;
		font-size: 11px;
		letter-spacing: 0.22px;

		input[type=checkbox] {
			width: 12px;
			height: 12px;
	}
}
`;

// ONSITE-LOCATION ENTRY ELEMENTS

export const EntryHeader = styled.h4`
	font-size: 20px;
	font-weight: 600;
	line-height: 32px;
	letter-spacing: -0.2px;
	margin-bottom: 8px;
`;

export const EntryDropdownButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 8px 16px 10px 32px;
	margin-bottom: 16px;
	gap: 4px;
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.04);
	max-width: 900px;

	:hover, :active {
		background: rgba(255, 255, 255, 0.04);
	}

	&.open {
		background: rgba(9, 9, 10, 0.30);
	}

	&.single {
		padding-right: 32px;
		cursor: default;
	}
	
	svg { 
		path {
			fill: #FFF97D !important;
		}
	}
`;

export const EntryDropdownButtonText = styled.h2`
	font-size: 30px;
	font-weight: 700;
	line-height: 40px;
	background: linear-gradient(90deg, #FF6AE6 0%, #FFF85C 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	margin-bottom: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const EntryDropdownOption = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 16px;
	background: #312F38;
	min-height: 36px;;

	&.header {
		padding: 8px 16px;
		color: #908CA0;
	}

	&:not(.header) {
		cursor: pointer;

		&:hover {
			background: #3C3A42;
		}
	}
`;

export const EntrySpan = styled.span`
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	opacity: 0.6;
	margin-bottom: 24px;
`;

export const EntryDropdown = styled.div`
	position: absolute;
	top: 62px;
	display: flex;
	flex-direction: column;
	width: 100%;
	border-radius: 12px;
	background: #312F38;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
	z-index: 99;
	opacity: 0;
	visibility: hidden;
	pointer-events: none;
	transition: 250ms all,
	250ms opacity,
	250ms visibility;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: calc(100vh - 492px);

	&.open {
		opacity: 1;
		visibility: visible;
		pointer-events: auto;
	}

	&.connection {
		top: 52px;
		background: rgba(255, 255, 255, 0.05);

		${EntryDropdownOption} {
			padding: 14px 16px;
			background: transparent;

			span {
				color: #E5E4EC;
			}

			&:not(.header) {
				cursor: pointer;

				&:hover {
					background: rgba(255, 255, 255, 0.10);
				}
			}
		}
	}
`;

export const EntryButtonRow = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const SrtCredentialsPanel = styled.div`
	position: absolute;
	width: 424px;
	top: 52px;
	border-radius: 12px;
	padding: 16px 16px 8px 16px;
	background: rgba(255, 255, 255, 0.05);
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
	z-index: 99;
	opacity: 0;
	visibility: hidden;
	pointer-events: none;
	transition: 250ms all,
	250ms opacity,
	250ms visibility;

	&.open {
		opacity: 1;
		visibility: visible;
		pointer-events: auto;
	}
`;

export const SrtCredentialsInput = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 6px;

	label {
		font-size: 11px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 1.3px;
		text-transform: uppercase;
		color: #9B97A1;
	}

	.credential {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 282px;
		height: 32px;
		padding: 6px 7px 6px 12px;
		gap: 6px;
		flex-shrink: 0;
		border-radius: 50px;
		background: rgba(255, 255, 255, 0.05);

		span {
			font-size: 12px;
			font-weight: 500;
			line-height: 16px;
			letter-spacing: 0.24px;
			color: #908CA0;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

	.copy-button {
		background: none;
		border: none;
		color: #908CA0;
		cursor: pointer;
		padding: 4px;
		transition: 250ms all;

		&:hover {
			svg>path {
				fill: #E5E4EC !important;
			}
		}
	}
`;

export const SrtCredentialsCopyAll = styled.div`
	display: flex;
	justify-content: flex-end;

	.copy-all-button {
		color: #BFBBCF;
		font-size: 11px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 0.22px;
		padding: 8px 0;
		cursor: pointer;
		transition: 250ms all;
		background: none;

		&:hover {
			color: #E5E4EC;
		}
	}
`;

// ONSITE-LOCATION PUBLISHING ELEMENTS

export const PublisherContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 72px;
	margin-bottom: 48px;
`;

export const VideoElContainer = styled.div`
	width: 560px;
	max-width: 560px;
	height: 100%;
	grid-column: 1 / 4;
	clip-path: inset(0 0 0 0 round 16px);
	overflow: hidden;
	aspect-ratio: 16 / 9;
	background: #26242B;
	z-index: 1;
	position: relative;
	margin-bottom: 24px;

	.poster {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: none;

		&.active {
			display: block;
		}

		img {
			object-fit: cover;
			min-height: 101%;
			max-height: 101%;
			max-width: 101%;
			min-width: 101%;
		}
	}
`;

export const VideoButtonsContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: center;

	button {
		&.left {
			position: absolute;
			left: 0;

			:active {
				label {
					color: #FF5F7F !important;
				}

				svg>path {
					fill: #FF5F7F !important;
				}
			}
		}

		&.right {
			position: absolute;
			right: 0;
		}
	}
`;

export const MuteButtonsContainer = styled.div`
	display: flex;
	gap: 16px;

	button {
		padding: 14px;

		:active {
			background: rgba(255, 255, 255, 0.15);

			svg>path {
				fill: #E5E4EC !important;
			}
		}

		&.off {
			background: #EC0C00;

			:hover {
				background: #DE352C;
			}

			:active {
				svg>path {
					fill: #FFFFFF !important;
				}				
			}
		}
	}
`;

export const RightPanelWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 388px;
`;

export const RightPanelContainer = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	width: 376px;
	max-height: 387px;
	transition: all 250ms ease-in;

	&.not-active {
		left: 100%;
		opacity: 0;
		pointer-events: none;
	}

	&.active {
		left: 0;
		opacity: 1;
		pointer-events: auto;
	}
`;

export const RightPanelHeader = styled.h3`
	text-transform: none !important;
	font-size: 23px;
	font-weight: 700;
	line-height: 32px;
	background: linear-gradient(109deg, #FF6AE6 -4.67%, #FFF85C 69.07%, #A6FF79 120.95%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	white-space: pre-line;
	
	.icon {
		margin-right: 8px;
	}
		
	&.small-gradient {
		background: linear-gradient(150deg, #FF6AE6 -4.67%, #FFF85C 140%, #A6FF79 120.95%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		margin: 0;
	}
`;

export const DeviceSelectionContainer = styled.div`
	display: flex;
	flex-direction: column;

	h6 {
		display: flex;
		align-items: center;
		color: #FFFFFF;
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
		gap: 8px;
		margin-bottom: 12px;
	}

	.option-row {
		.select-small {
			margin-bottom: 24px;

			.select-label.dropdown {
				padding: 12px 16px;
				border-radius: 20px;
				border: 1px solid #908CA0;
				background: transparent;
			}
		}
	}
`;

export const ScrollContainer = styled.div`
	overflow-y: scroll;
	position: relative;
	height: 96%;
`;

export const RemoveEffectsButton = styled.button`
	border-radius: 100px;
	background: rgba(255, 255, 255, 0.05);
	color: #908CA0;
	border: none;
	padding: 8px 16px;
	display: flex;
	align-items: center;
	margin-right: 16px;

	.icon {
		margin-right: 8px;
	}

	&:hover {
		background: rgba(255, 255, 255, 0.1);
	}

	&:active {
		background: rgba(255, 255, 255, 0.05);
	}
`;
